module.exports = require('../_components/@alicd/next-select/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/select/index.js
// module id = 106
// module chunks = 0